import { API_CONFIG } from '@/project/configs/api.js'

export default {
  url(payload) {
    const params = new URLSearchParams()
    params.append('group', 'ultraxeno')
    params.append('limit', 2000)
    return `${API_CONFIG.baseURL}/sidedish/list?${params.toString()}`
  },

  parse(raw = {}, payload = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
      }
    }

    // L'API /sidedish/list retourne un tableau direct dans data
    const accompaniementsData = Array.isArray(raw?.data) ? raw.data : []

    // === Mapping des données ===
    // L'API V3 retourne "price" (pas "amount") et "isActive" (pas "active")
    let data = accompaniementsData.map(el => ({
      id: el.id,
      name: el.name,
      price: el.price || 0,
      image: el.image || '',
      description: el.description || null,
      isActive: el.isActive,
      activeStatus: el.isActive ? 'active' : 'inactive',
      currency: el.currency || 'XOF',
      createdAt: el.createdAt || null,
      updatedAt: el.updatedAt || null,
    }))

    // === Recherche textuelle locale ===
    if (payload?.search) {
      const searchLower = payload.search.toString().toLowerCase()
      data = data.filter(el => {
        if (el?.id?.toLowerCase().includes(searchLower)) return true
        if (el?.name?.toLowerCase().includes(searchLower)) return true
        if (el?.description?.toLowerCase().includes(searchLower)) return true
        if (el?.price?.toString().includes(searchLower)) return true
        return false
      })
    }

    // === Tri dynamique ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: data.length,
        result: paginated,
      },
    }
  },
}
